import type { ProLayoutProps } from '@ant-design/pro-components';
import { BRAND_LOGO, BRAND_PRIMARY_COLOR, BRAND_TITLE } from '../src/constants/brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  // 不写死 navTheme：让 ProLayout 跟随 ConfigProvider 的明暗算法
  colorPrimary: BRAND_PRIMARY_COLOR,
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  colorWeak: false,
  title: BRAND_TITLE,
  pwa: true,
  logo: BRAND_LOGO,
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
  },
};

export default Settings;
